import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import BlogPage from './BlogPage.component';
import BreadcrumbsDispatcher from '@scandipwa/scandipwa/src/store/Breadcrumbs/Breadcrumbs.dispatcher';
import { fetchQuery } from '@scandipwa/scandipwa/src/util/Request/Query';
import BlogPostsQuery from 'Query/BlogPosts.query';
import MetaDispatcher from '@scandipwa/scandipwa/src/store/Meta/Meta.dispatcher';
import { updateMeta } from '@scandipwa/scandipwa/src/store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { NavigationType } from 'Store/Navigation/Navigation.type';

/** @namespace Route/CmsPage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
});

/** @namespace Route/CmsPage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateBreadcrumbs: (breadcrumbs) => BreadcrumbsDispatcher.update(breadcrumbs, dispatch),
    updateMeta: (meta) => dispatch(updateMeta(meta)),
    setHeaderState: (stateName) => dispatch(changeNavigationState(NavigationType.TOP_NAVIGATION_TYPE, stateName)),
});

export class BlogPageContainer extends PureComponent {
    static propTypes = {
        device: this.propTypes,
        updateBreadcrumbs: this.propTypes,
        updateMeta: this.propTypes,
        setHeaderState: this.propTypes
    }

    state = {
        blogPosts: {}
    }

    async componentDidMount() {
        this.updateBreadcrumbs();
        this.uppdateMeta();
        this.updateHeader();

        const option = {
            filter: {
                category_id: {
                    eq: 9
                }
            }
        };

        const { blogPosts } = await fetchQuery(BlogPostsQuery.getQuery(option));
        this.setState({
            blogPosts: blogPosts
        });
    }

    componentDidUpdate() {
        this.updateBreadcrumbs();
        this.uppdateMeta();
        this.updateHeader();
    }

    uppdateMeta() {
        const { updateMeta } = this.props;

        updateMeta({
            title: "Blog",
            description: "Blog",
            keywords: "Blog",
            canonical_url: window.location.href,
        });
    }

    updateBreadcrumbs() {
        const { updateBreadcrumbs } = this.props;

        const breadcrumbs = [
            {
                url: '/blogs',
                name: 'Blog',
            },
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    updateHeader() {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: "Blog",
            title: "Blog",
        });
    }

    containerProps() {
        const { device } = this.props;
        const { blogPosts } = this.state;

        return {
            device,
            blogPosts
        };
    }

    render() {
        return (
            <BlogPage
                {...this.containerProps()}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogPageContainer);
